// import useIsDesktop from "@hooks/useIsDesktop"
import useNavigationLinks from "@hooks/useNavigationLinks"
import useRouter from "@hooks/useRouter"
import useUser from "@hooks/useUser"

// import { faIcon } from "@utils/faIcon"
import filterUserLinks from "@utils/filterUserLinks"

// import { Button } from "@atoms/index"
import { TopBar } from "@organisms"
import ViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider"

import { AppFrame } from "@templates"

// import JobSeriesCreateDialog from "@pages/JobSeries/JobSeriesCreateDialog/JobSeriesCreateDialog"
import JobSeriesTableView from "@pages/JobSeries/JobSeriesList/views/JobSeriesTableView/JobSeriesTableView"

import { objectMap } from "@constants/objectMap"
import { JOBS_SERIES_LIST_CONTROLS_VIEW } from "@constants/storage"

function JobSeriesListContent() {
    const { user } = useUser()
    const router = useRouter()
    // const isDesktop = useIsDesktop()
    const { jobs: jobsLink } = useNavigationLinks()

    const sublinks = filterUserLinks(jobsLink.subLinks, user)

    return (
        <ViewTypesProvider viewTypeKey={JOBS_SERIES_LIST_CONTROLS_VIEW} defaultViewType="table">
            {() => (
                <>
                    <TopBar.Root>
                        <TopBar.Header>
                            <TopBar.TopBarHeaderStart>
                                <TopBar.PageTitle
                                    label={objectMap.job_series.labelPlural}
                                    icon={objectMap.job_series.iconActive}
                                    navigationItems={
                                        sublinks.length > 1
                                            ? sublinks.map((item) => ({
                                                  label: item.label,
                                                  value: item.path,
                                                  isActive: item.label === "Job Series",
                                              }))
                                            : undefined
                                    }
                                    onNavigationItemSelect={(item) => {
                                        router.push(item.value)
                                    }}
                                />
                            </TopBar.TopBarHeaderStart>
                            <TopBar.TopBarHeaderEnd>
                                <TopBar.PagePresence />
                                <TopBar.ViewSelector viewTypes={["table"]} />
                                {/* TODO: Re-enable create new job series CTA
                                <JobSeriesCreateDialog>
                                    <Button
                                        size={isDesktop ? "md" : "lg"}
                                        variant="solid"
                                        leftIcon={faIcon({ name: "plus", style: "solid" })}
                                        noDebounce={true}
                                    >
                                        {isDesktop ? "New" : null}
                                    </Button>
                                </JobSeriesCreateDialog>
                                */}
                            </TopBar.TopBarHeaderEnd>
                        </TopBar.Header>
                    </TopBar.Root>
                    <JobSeriesTableView />
                </>
            )}
        </ViewTypesProvider>
    )
}

export default function JobSeriesList() {
    return (
        <AppFrame.Root pageId="JobSeriesList">
            <JobSeriesListContent />
        </AppFrame.Root>
    )
}
